import styled from '@emotion/styled'
import React from 'react'
import { useIsTesting } from '../hooks/use-is-testing'

const paddingVariants = (isTesting: boolean) => ({
  normal: `${isTesting ? '121px' : '95px'} 20px 0 20px`,
  fullScreen: `${isTesting ? '95px' : '56px'} 0px 0px 0px`,
  onlyTop: `${isTesting ? '121px' : '95px'} 0px 0px 0px`,
})

const ContainerStyled = styled.div(
  ({
    isTesting,
    variant = 'normal',
  }: {
    isTesting: boolean
    variant?: 'normal' | 'fullScreen' | 'onlyTop'
  }) => ({
    padding: paddingVariants(isTesting)[variant],
  }),
)

export const MFEWrapper = ({
  children,
  variant,
}: {
  children: React.ReactElement
  variant?: 'normal' | 'fullScreen' | 'onlyTop'
}) => {
  const { isTesting } = useIsTesting()

  return (
    <ContainerStyled variant={variant} isTesting={isTesting}>
      {children}
    </ContainerStyled>
  )
}
